// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1c1MX","savePackageButton":"ClientWallet_savePackageButton__s9ttM"};